module.exports = __webpack_public_path__ + "static/media/icon-c1.c14b00c7.svg";